import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useToggle } from 'react-use';
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import cn from 'classnames';

import useContentCrud from '../../../pages/ContentPage/useContentCrud';
import ContentUploadModal from './ContentUploadModal';
import ContentAddSiteModal from './ContentAddSiteModal';

function ContentToolbar({ className }) {
  const { t } = useTranslation();
  const [showUploadModal, toggleUploadModal] = useToggle(false);
  const [showAddWebSite, toggleAddWebsite] = useToggle(false);
  const { onFetch, onAddLink, onAddFiles, onDelete } = useContentCrud({
    fetchOnInit: false,
    onAddLinkSuccess: () => {
      toggleAddWebsite();
      onFetch();
    },
    onAddFilesSuccess: toggleUploadModal,
  });

  return (
    <div className={cn('content-toolbar', className)}>
      <ContentUploadModal
        t={t}
        onFetch={onFetch}
        isOpen={showUploadModal}
        toggle={toggleUploadModal}
        onSubmit={onAddFiles}
        onDelete={onDelete}
      />
      <ContentAddSiteModal
        t={t}
        isOpen={showAddWebSite}
        toggle={toggleAddWebsite}
        onSubmit={onAddLink}
      />

      <Button
        icon={<UploadOutlined width={16} height={16} />}
        type="primary"
        onClick={toggleUploadModal}
      >
        {t('upload')}
      </Button>

      <Button
        icon={<PlusOutlined width={16} height={16} />}
        onClick={toggleAddWebsite}
        type="primary"
      >
        {t('add-website')}
      </Button>
    </div>
  );
}

export default ContentToolbar;
